import {
	Draggable,
	DraggableProvided,
	DraggableStateSnapshot,
} from '@hello-pangea/dnd';
import React from 'react';
import {
	InvoiceEditLineItem,
	InvoiceEditLineItemProps,
} from '../InvoiceEditLineItem/InvoiceEditLineItem';

export type InvoiceEditDraggableLineItemProps = {
	draggableId: string;
	index: number;
} & Pick<
InvoiceEditLineItemProps,
| 'invoiceExists'
| 'invoice'
| 'lineItem'
| 'lineItemDetails'
| 'autoFocus'
| 'onUpdate'
| 'onRemove'
| 'onBlur'
| 'rateLabel'
>;

export const InvoiceEditDraggableLineItem: React.FC<
InvoiceEditDraggableLineItemProps
> = ( { draggableId, index, ...props } ) => (
	<Draggable key={ draggableId } draggableId={ draggableId } index={ index }>
		{ ( provided: DraggableProvided, snapshot: DraggableStateSnapshot ) => (
			<InvoiceEditLineItem
				{ ...props }
				provided={ provided }
				isDragging={ snapshot.isDragging }
			/>
		) }
	</Draggable>
);
